import { jsx as _jsx } from "react/jsx-runtime";
import { getCidades } from './cidades_service';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'uf', headerName: 'UF', width: 200 },
    { field: 'codigo_ibge', headerName: 'Código IBGE', width: 200 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export function CidadesListar() {
    return _jsx(GridBase, { pagina: PAGINAS.CIDADES, paginaPermissao: FUNCIONALIDADES.CIDADES, rota: ROUTES.CIDADES, fetchData: function (str, _, pag) { return getCidades(str, pag); }, columns: COLUNAS });
}
export default CidadesListar;
